import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { ProjectType } from '../models/ProjectType'
import { ProjectTypeForm } from '../forms/ProjectTypeForm'
import { ProjectTypeFilter } from '../filters/ProjectTypeFilter'
import { ProjectTypeService } from '../services/ProjectTypeService'

export const useProjectTypeStore: KsStoreHook<ProjectType, ProjectTypeForm, ProjectTypeFilter> = createKsStore({
  id: 'projectTypes',
  modelClass: ProjectType,
  formClass: ProjectTypeForm,
  filterClass: ProjectTypeFilter,
  service: ProjectTypeService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Type #${item.id}`,
  signalREventName: 'ProjectTypeModel',
  isReferential: true
})
